import { useContext } from "react";
import { GlobalConfigContext } from "../../../context/GlobalConfigContext";
import { useSegmentProcessor } from "../../../hooks/useSegmentProcessor";
import { getDateWithFormat } from "../../../utils/commons";
import ButtonGroupDynamic from "../../common/ButtonGroupDynamic";
import "../../common/GridCard.scss";

const BonusGridCard = ({ campaign, actionButtons }) => {
  const {
    title,
    status,
    titleShort,
    uniqueSegmentedUsersCount,
    activeStartDate,
    activeEndDate,
    summary,
  } = campaign;
  const { displaySegment, totalPopulation } = useSegmentProcessor(campaign);
  const { programTimezone } = useContext(GlobalConfigContext);

  // Styles object for card container
  const styles = {
    cardContainer: {
      width: "100%",
      padding: "16px",
      borderRadius: "10px",
      background: "rgba(255, 255, 255, 1)",
      boxShadow: "0px 0px 10px 0px rgba(0,0,0,0.1)",
      minHeight: "220px",
    },
  };

  // Reusable FieldPair component
  const FieldPair = ({ label, value }) => (
    <div className="field-pair">
      <span className="field-label">{label}</span>
      <span className="field-value">{value}</span>
    </div>
  );

  return (
    <div style={styles.cardContainer} className="bonus-grid-card">
      <div className="campaign-card-container">
        <div className="campaign-details">
          {/* Campaign Status */}
          <div className="campaign-status-type">
            <span
              className={`status ${status?.toLowerCase()}`}
              aria-label={`Campaign status: ${status || "Unknown"}`}
            >
              {status
                ? status.charAt(0).toUpperCase() + status.slice(1).toLowerCase()
                : "-"}
            </span>
          </div>

          {/* Campaign Title */}
          <h3
            className="campaign-name"
            aria-label={`Campaign title: ${title || "Unknown"}`}
          >
            {title || "-"}
          </h3>

          {/* Additional Fields */}
          <div className="additional-fields-container">
            <FieldPair label="Campaign Short Name" value={titleShort} />
            <FieldPair label="Segment" value={displaySegment} />
            <FieldPair label="Population" value={totalPopulation} />
            <FieldPair label="Unique Users" value={uniqueSegmentedUsersCount || 0} />
            <FieldPair label="Success Count" value={summary?.successCount || 0} />
            <FieldPair label="Failure Count" value={summary?.failureCount || 0} />
            <FieldPair
              label="Create Date"
              value={
                activeStartDate
                  ? getDateWithFormat(
                      activeStartDate,
                      programTimezone,
                      "DD/MM/YYYY hh:mm a"
                    )
                  : "N/A"
              }
            />
            <FieldPair
              label="Job Running Date"
              value={
                activeEndDate
                  ? getDateWithFormat(
                      activeEndDate,
                      programTimezone,
                      "DD/MM/YYYY hh:mm a"
                    )
                  : "N/A"
              }
            />
          </div>

          {/* Action Buttons */}
          <div className="button-group-container">
            <ButtonGroupDynamic
              items={actionButtons}
              spacing="1px"
              size="small"
              variant="control"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BonusGridCard;
